<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>apps</mat-icon></div>
          <mat-card-title>
            Segmento (Sistema)
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Código</mat-label>
                <input matInput formControlName="codigo" placeholder="Ex.: WOW_VE" [readonly]="!!formulario.value.id">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-5">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nome" required>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Ordem</mat-label>
                <input matInput type="number" formControlName="ordem">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Situação</mat-label>
                <mat-select formControlName="ativo">
                  <mat-option [value]="true">Ativo</mat-option>
                  <mat-option [value]="false">Inativo</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Descrição</mat-label>
                <textarea matInput formControlName="descricao" rows="3"></textarea>
              </mat-form-field>
            </div>

            <div class="col-12">
              <label class="segmento-logo__titulo">Dados do servidor</label>
            </div>
            <div class="col-12 col-md">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>URL do sistema</mat-label>
                <input matInput formControlName="urlSistema" placeholder="Ex.: https://wowve.com.br">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Fornecedor / Host</mat-label>
                <input matInput formControlName="fornecedorServidor" placeholder="Ex.: Hostgator, AWS">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>IP do servidor</mat-label>
                <input matInput formControlName="ipServidor" placeholder="Ex.: 191.252.102.237">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Usuário (root)</mat-label>
                <input matInput formControlName="usuarioRootServidor" placeholder="Ex.: root" autocomplete="off">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Senha de acesso</mat-label>
                <input matInput formControlName="senhaServidor" autocomplete="new-password"
                  [type]="ocultarSenhaServidor ? 'password' : 'text'">
                <button type="button" mat-icon-button matSuffix
                  (click)="ocultarSenhaServidor = !ocultarSenhaServidor"
                  [attr.aria-label]="'Mostrar senha'" [attr.aria-pressed]="!ocultarSenhaServidor">
                  <mat-icon>{{ ocultarSenhaServidor ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-12">
              <label class="segmento-logo__titulo">Logo do projeto</label>
              <p class="segmento-logo__hint">
                Usada no Bolepix gerado para cobranças deste segmento. PNG/JPG, até 1 MB.
              </p>
              <div class="segmento-logo">
                <div class="segmento-logo__preview">
                  <img *ngIf="logoPreview" [src]="logoPreview" alt="Logo do segmento" />
                  <div *ngIf="!logoPreview" class="segmento-logo__placeholder">
                    <mat-icon>image</mat-icon>
                    <span>Sem logo</span>
                  </div>
                </div>
                <div class="segmento-logo__acoes">
                  <button type="button" mat-stroked-button (click)="inputLogo.click()">
                    <mat-icon>upload</mat-icon> Selecionar logo
                  </button>
                  <button type="button" mat-stroked-button color="warn" *ngIf="logoPreview" (click)="removerLogo()">
                    <mat-icon>delete</mat-icon> Remover
                  </button>
                  <span class="segmento-logo__nome" *ngIf="formulario.value.logoNomeArquivo">
                    {{ formulario.value.logoNomeArquivo }}
                  </span>
                </div>
                <input #inputLogo type="file" accept="image/*" hidden (change)="onLogoSelecionada($event)" />
              </div>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button (click)="limpar()">
              <mat-icon>clear</mat-icon> Limpar
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
